import { c as _c } from "react/compiler-runtime";
import type { ApiNodeData, NodeKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { NodeIconProps } from '../components/node-icon';
import { nodeIconConfigs } from '../components/node-icon-config';
export type NodeLabel = {
  uppercase: string;
  lowercase: string;
};
export type NodeInfo = {
  title: NodeLabel;
  subtitle: string;
  description: string;
  icon: NodeIconProps;
};
type SupportedNodeKind = ApiNodeData['kind'] | NodeKind | 'vendor_integration';
export const useGetStaticNodeInfo = () => {
  const $0 = _c(227);
  const {
    t
  } = useTranslation("playbook-builder");
  let t0;
  if ($0[0] !== t) {
    t0 = selector => ({
      uppercase: t($ => selector($).uppercase),
      lowercase: t($_0 => selector($_0).lowercase)
    });
    $0[0] = t;
    $0[1] = t0;
  } else {
    t0 = $0[1];
  }
  const createLabel = t0;
  let t1;
  if ($0[2] !== createLabel) {
    t1 = {
      collect_data: createLabel(_temp),
      collect_custom_data: createLabel(_temp2),
      custom_data: createLabel(_temp3),
      investor_profile: createLabel(_temp4),
      identity_data: createLabel(_temp5),
      business_data: createLabel(_temp6),
      collect_card_data: createLabel(_temp7),
      bank_link: createLabel(_temp8),
      authentication: createLabel(_temp9),
      collect_document: createLabel(_temp10),
      custom_document: createLabel(_temp11),
      identity_document: createLabel(_temp12),
      selfie: createLabel(_temp13),
      verification_check: createLabel(_temp14),
      verified_prefill: createLabel(_temp15),
      bo_kyc: createLabel(_temp16),
      conditional: createLabel(_temp17),
      rules: createLabel(_temp18),
      action: createLabel(_temp19),
      taktile: createLabel(_temp20),
      input_schema: createLabel(_temp21),
      prerequisite: createLabel(_temp22),
      output: createLabel(_temp23),
      complete: createLabel(_temp24),
      branch: createLabel(_temp25),
      external_api: createLabel(_temp26),
      vendor_integration: createLabel(_temp27),
      placeholder: createLabel(_temp28),
      join_point: createLabel(_temp29),
      assign_data: createLabel(_temp30),
      common_expression: createLabel(_temp31),
      code_exec: createLabel(_temp32),
      watchlist_review: createLabel(_temp33),
      document_extraction: createLabel(_temp34),
      ai_research: createLabel(_temp35),
      ai_decision: createLabel(_temp36)
    };
    $0[2] = createLabel;
    $0[3] = t1;
  } else {
    t1 = $0[3];
  }
  const labels = t1;
  let t2;
  if ($0[4] !== t) {
    t2 = t(_temp37);
    $0[4] = t;
    $0[5] = t2;
  } else {
    t2 = $0[5];
  }
  let t3;
  if ($0[6] !== t) {
    t3 = t(_temp38);
    $0[6] = t;
    $0[7] = t3;
  } else {
    t3 = $0[7];
  }
  let t4;
  if ($0[8] !== t) {
    t4 = t(_temp39);
    $0[8] = t;
    $0[9] = t4;
  } else {
    t4 = $0[9];
  }
  let t5;
  if ($0[10] !== t) {
    t5 = t(_temp40);
    $0[10] = t;
    $0[11] = t5;
  } else {
    t5 = $0[11];
  }
  let t6;
  if ($0[12] !== t) {
    t6 = t(_temp41);
    $0[12] = t;
    $0[13] = t6;
  } else {
    t6 = $0[13];
  }
  let t7;
  if ($0[14] !== t) {
    t7 = t(_temp42);
    $0[14] = t;
    $0[15] = t7;
  } else {
    t7 = $0[15];
  }
  let t8;
  if ($0[16] !== t) {
    t8 = t(_temp43);
    $0[16] = t;
    $0[17] = t8;
  } else {
    t8 = $0[17];
  }
  let t9;
  if ($0[18] !== t) {
    t9 = t(_temp44);
    $0[18] = t;
    $0[19] = t9;
  } else {
    t9 = $0[19];
  }
  let t10;
  if ($0[20] !== t) {
    t10 = t(_temp45);
    $0[20] = t;
    $0[21] = t10;
  } else {
    t10 = $0[21];
  }
  let t11;
  if ($0[22] !== t) {
    t11 = t(_temp46);
    $0[22] = t;
    $0[23] = t11;
  } else {
    t11 = $0[23];
  }
  let t12;
  if ($0[24] !== t) {
    t12 = t(_temp47);
    $0[24] = t;
    $0[25] = t12;
  } else {
    t12 = $0[25];
  }
  let t13;
  if ($0[26] !== t) {
    t13 = t(_temp48);
    $0[26] = t;
    $0[27] = t13;
  } else {
    t13 = $0[27];
  }
  let t14;
  if ($0[28] !== t) {
    t14 = t(_temp49);
    $0[28] = t;
    $0[29] = t14;
  } else {
    t14 = $0[29];
  }
  let t15;
  if ($0[30] !== t) {
    t15 = t(_temp50);
    $0[30] = t;
    $0[31] = t15;
  } else {
    t15 = $0[31];
  }
  let t16;
  if ($0[32] !== t) {
    t16 = t(_temp51);
    $0[32] = t;
    $0[33] = t16;
  } else {
    t16 = $0[33];
  }
  let t17;
  if ($0[34] !== t) {
    t17 = t(_temp52);
    $0[34] = t;
    $0[35] = t17;
  } else {
    t17 = $0[35];
  }
  let t18;
  if ($0[36] !== t) {
    t18 = t(_temp53);
    $0[36] = t;
    $0[37] = t18;
  } else {
    t18 = $0[37];
  }
  let t19;
  if ($0[38] !== t) {
    t19 = t(_temp54);
    $0[38] = t;
    $0[39] = t19;
  } else {
    t19 = $0[39];
  }
  let t20;
  if ($0[40] !== t) {
    t20 = t(_temp55);
    $0[40] = t;
    $0[41] = t20;
  } else {
    t20 = $0[41];
  }
  let t21;
  if ($0[42] !== t) {
    t21 = t(_temp56);
    $0[42] = t;
    $0[43] = t21;
  } else {
    t21 = $0[43];
  }
  let t22;
  if ($0[44] !== t) {
    t22 = t(_temp57);
    $0[44] = t;
    $0[45] = t22;
  } else {
    t22 = $0[45];
  }
  let t23;
  if ($0[46] !== t) {
    t23 = t(_temp58);
    $0[46] = t;
    $0[47] = t23;
  } else {
    t23 = $0[47];
  }
  let t24;
  if ($0[48] !== t) {
    t24 = t(_temp59);
    $0[48] = t;
    $0[49] = t24;
  } else {
    t24 = $0[49];
  }
  let t25;
  if ($0[50] !== t) {
    t25 = t(_temp60);
    $0[50] = t;
    $0[51] = t25;
  } else {
    t25 = $0[51];
  }
  let t26;
  if ($0[52] !== t) {
    t26 = t(_temp61);
    $0[52] = t;
    $0[53] = t26;
  } else {
    t26 = $0[53];
  }
  let t27;
  if ($0[54] !== t) {
    t27 = t(_temp62);
    $0[54] = t;
    $0[55] = t27;
  } else {
    t27 = $0[55];
  }
  let t28;
  if ($0[56] !== t) {
    t28 = t(_temp63);
    $0[56] = t;
    $0[57] = t28;
  } else {
    t28 = $0[57];
  }
  let t29;
  if ($0[58] !== t) {
    t29 = t(_temp64);
    $0[58] = t;
    $0[59] = t29;
  } else {
    t29 = $0[59];
  }
  let t30;
  if ($0[60] !== t) {
    t30 = t(_temp65);
    $0[60] = t;
    $0[61] = t30;
  } else {
    t30 = $0[61];
  }
  let t31;
  if ($0[62] !== t) {
    t31 = t(_temp66);
    $0[62] = t;
    $0[63] = t31;
  } else {
    t31 = $0[63];
  }
  let t32;
  if ($0[64] !== t) {
    t32 = t(_temp67);
    $0[64] = t;
    $0[65] = t32;
  } else {
    t32 = $0[65];
  }
  let t33;
  if ($0[66] !== t) {
    t33 = t(_temp68);
    $0[66] = t;
    $0[67] = t33;
  } else {
    t33 = $0[67];
  }
  let t34;
  if ($0[68] !== t) {
    t34 = t(_temp69);
    $0[68] = t;
    $0[69] = t34;
  } else {
    t34 = $0[69];
  }
  let t35;
  if ($0[70] !== t) {
    t35 = t(_temp70);
    $0[70] = t;
    $0[71] = t35;
  } else {
    t35 = $0[71];
  }
  let t36;
  if ($0[72] !== t) {
    t36 = t(_temp71);
    $0[72] = t;
    $0[73] = t36;
  } else {
    t36 = $0[73];
  }
  let t37;
  if ($0[74] !== t) {
    t37 = t(_temp72);
    $0[74] = t;
    $0[75] = t37;
  } else {
    t37 = $0[75];
  }
  let t38;
  if ($0[76] !== t10 || $0[77] !== t11 || $0[78] !== t12 || $0[79] !== t13 || $0[80] !== t14 || $0[81] !== t15 || $0[82] !== t16 || $0[83] !== t17 || $0[84] !== t18 || $0[85] !== t19 || $0[86] !== t2 || $0[87] !== t20 || $0[88] !== t21 || $0[89] !== t22 || $0[90] !== t23 || $0[91] !== t24 || $0[92] !== t25 || $0[93] !== t26 || $0[94] !== t27 || $0[95] !== t28 || $0[96] !== t29 || $0[97] !== t3 || $0[98] !== t30 || $0[99] !== t31 || $0[100] !== t32 || $0[101] !== t33 || $0[102] !== t34 || $0[103] !== t35 || $0[104] !== t36 || $0[105] !== t37 || $0[106] !== t4 || $0[107] !== t5 || $0[108] !== t6 || $0[109] !== t7 || $0[110] !== t8 || $0[111] !== t9) {
    t38 = {
      identity_data: t2,
      collect_data: t3,
      business_data: t4,
      collect_card_data: t5,
      bank_link: t6,
      authentication: t7,
      assign_data: t8,
      watchlist_review: t9,
      document_extraction: t10,
      ai_research: t11,
      ai_decision: t12,
      common_expression: t13,
      code_exec: t14,
      investor_profile: t15,
      identity_document: t16,
      selfie: t17,
      conditional: t18,
      rules: t19,
      verification_check: t20,
      action: t21,
      verified_prefill: t22,
      bo_kyc: t23,
      taktile: t24,
      input_schema: t25,
      prerequisite: t26,
      output: t27,
      complete: t28,
      branch: t29,
      external_api: t30,
      vendor_integration: t31,
      collect_custom_data: t32,
      custom_data: t33,
      collect_document: t34,
      custom_document: t35,
      placeholder: t36,
      join_point: t37
    };
    $0[76] = t10;
    $0[77] = t11;
    $0[78] = t12;
    $0[79] = t13;
    $0[80] = t14;
    $0[81] = t15;
    $0[82] = t16;
    $0[83] = t17;
    $0[84] = t18;
    $0[85] = t19;
    $0[86] = t2;
    $0[87] = t20;
    $0[88] = t21;
    $0[89] = t22;
    $0[90] = t23;
    $0[91] = t24;
    $0[92] = t25;
    $0[93] = t26;
    $0[94] = t27;
    $0[95] = t28;
    $0[96] = t29;
    $0[97] = t3;
    $0[98] = t30;
    $0[99] = t31;
    $0[100] = t32;
    $0[101] = t33;
    $0[102] = t34;
    $0[103] = t35;
    $0[104] = t36;
    $0[105] = t37;
    $0[106] = t4;
    $0[107] = t5;
    $0[108] = t6;
    $0[109] = t7;
    $0[110] = t8;
    $0[111] = t9;
    $0[112] = t38;
  } else {
    t38 = $0[112];
  }
  const subtitles = t38;
  let t39;
  if ($0[113] !== t) {
    t39 = t(_temp73);
    $0[113] = t;
    $0[114] = t39;
  } else {
    t39 = $0[114];
  }
  let t40;
  if ($0[115] !== t) {
    t40 = t(_temp74);
    $0[115] = t;
    $0[116] = t40;
  } else {
    t40 = $0[116];
  }
  let t41;
  if ($0[117] !== t) {
    t41 = t(_temp75);
    $0[117] = t;
    $0[118] = t41;
  } else {
    t41 = $0[118];
  }
  let t42;
  if ($0[119] !== t) {
    t42 = t(_temp76);
    $0[119] = t;
    $0[120] = t42;
  } else {
    t42 = $0[120];
  }
  let t43;
  if ($0[121] !== t) {
    t43 = t(_temp77);
    $0[121] = t;
    $0[122] = t43;
  } else {
    t43 = $0[122];
  }
  let t44;
  if ($0[123] !== t) {
    t44 = t(_temp78);
    $0[123] = t;
    $0[124] = t44;
  } else {
    t44 = $0[124];
  }
  let t45;
  if ($0[125] !== t) {
    t45 = t(_temp79);
    $0[125] = t;
    $0[126] = t45;
  } else {
    t45 = $0[126];
  }
  let t46;
  if ($0[127] !== t) {
    t46 = t(_temp80);
    $0[127] = t;
    $0[128] = t46;
  } else {
    t46 = $0[128];
  }
  let t47;
  if ($0[129] !== t) {
    t47 = t(_temp81);
    $0[129] = t;
    $0[130] = t47;
  } else {
    t47 = $0[130];
  }
  let t48;
  if ($0[131] !== t) {
    t48 = t(_temp82);
    $0[131] = t;
    $0[132] = t48;
  } else {
    t48 = $0[132];
  }
  let t49;
  if ($0[133] !== t) {
    t49 = t(_temp83);
    $0[133] = t;
    $0[134] = t49;
  } else {
    t49 = $0[134];
  }
  let t50;
  if ($0[135] !== t) {
    t50 = t(_temp84);
    $0[135] = t;
    $0[136] = t50;
  } else {
    t50 = $0[136];
  }
  let t51;
  if ($0[137] !== t) {
    t51 = t(_temp85);
    $0[137] = t;
    $0[138] = t51;
  } else {
    t51 = $0[138];
  }
  let t52;
  if ($0[139] !== t) {
    t52 = t(_temp86);
    $0[139] = t;
    $0[140] = t52;
  } else {
    t52 = $0[140];
  }
  let t53;
  if ($0[141] !== t) {
    t53 = t(_temp87);
    $0[141] = t;
    $0[142] = t53;
  } else {
    t53 = $0[142];
  }
  let t54;
  if ($0[143] !== t) {
    t54 = t(_temp88);
    $0[143] = t;
    $0[144] = t54;
  } else {
    t54 = $0[144];
  }
  let t55;
  if ($0[145] !== t) {
    t55 = t(_temp89);
    $0[145] = t;
    $0[146] = t55;
  } else {
    t55 = $0[146];
  }
  let t56;
  if ($0[147] !== t) {
    t56 = t(_temp90);
    $0[147] = t;
    $0[148] = t56;
  } else {
    t56 = $0[148];
  }
  let t57;
  if ($0[149] !== t) {
    t57 = t(_temp91);
    $0[149] = t;
    $0[150] = t57;
  } else {
    t57 = $0[150];
  }
  let t58;
  if ($0[151] !== t) {
    t58 = t(_temp92);
    $0[151] = t;
    $0[152] = t58;
  } else {
    t58 = $0[152];
  }
  let t59;
  if ($0[153] !== t) {
    t59 = t(_temp93);
    $0[153] = t;
    $0[154] = t59;
  } else {
    t59 = $0[154];
  }
  let t60;
  if ($0[155] !== t) {
    t60 = t(_temp94);
    $0[155] = t;
    $0[156] = t60;
  } else {
    t60 = $0[156];
  }
  let t61;
  if ($0[157] !== t) {
    t61 = t(_temp95);
    $0[157] = t;
    $0[158] = t61;
  } else {
    t61 = $0[158];
  }
  let t62;
  if ($0[159] !== t) {
    t62 = t(_temp96);
    $0[159] = t;
    $0[160] = t62;
  } else {
    t62 = $0[160];
  }
  let t63;
  if ($0[161] !== t) {
    t63 = t(_temp97);
    $0[161] = t;
    $0[162] = t63;
  } else {
    t63 = $0[162];
  }
  let t64;
  if ($0[163] !== t) {
    t64 = t(_temp98);
    $0[163] = t;
    $0[164] = t64;
  } else {
    t64 = $0[164];
  }
  let t65;
  if ($0[165] !== t) {
    t65 = t(_temp99);
    $0[165] = t;
    $0[166] = t65;
  } else {
    t65 = $0[166];
  }
  let t66;
  if ($0[167] !== t) {
    t66 = t(_temp100);
    $0[167] = t;
    $0[168] = t66;
  } else {
    t66 = $0[168];
  }
  let t67;
  if ($0[169] !== t) {
    t67 = t(_temp101);
    $0[169] = t;
    $0[170] = t67;
  } else {
    t67 = $0[170];
  }
  let t68;
  if ($0[171] !== t) {
    t68 = t(_temp102);
    $0[171] = t;
    $0[172] = t68;
  } else {
    t68 = $0[172];
  }
  let t69;
  if ($0[173] !== t) {
    t69 = t(_temp103);
    $0[173] = t;
    $0[174] = t69;
  } else {
    t69 = $0[174];
  }
  let t70;
  if ($0[175] !== t) {
    t70 = t(_temp104);
    $0[175] = t;
    $0[176] = t70;
  } else {
    t70 = $0[176];
  }
  let t71;
  if ($0[177] !== t) {
    t71 = t(_temp105);
    $0[177] = t;
    $0[178] = t71;
  } else {
    t71 = $0[178];
  }
  let t72;
  if ($0[179] !== t) {
    t72 = t(_temp106);
    $0[179] = t;
    $0[180] = t72;
  } else {
    t72 = $0[180];
  }
  let t73;
  if ($0[181] !== t) {
    t73 = t(_temp107);
    $0[181] = t;
    $0[182] = t73;
  } else {
    t73 = $0[182];
  }
  let t74;
  if ($0[183] !== t) {
    t74 = t(_temp108);
    $0[183] = t;
    $0[184] = t74;
  } else {
    t74 = $0[184];
  }
  let t75;
  if ($0[185] !== t39 || $0[186] !== t40 || $0[187] !== t41 || $0[188] !== t42 || $0[189] !== t43 || $0[190] !== t44 || $0[191] !== t45 || $0[192] !== t46 || $0[193] !== t47 || $0[194] !== t48 || $0[195] !== t49 || $0[196] !== t50 || $0[197] !== t51 || $0[198] !== t52 || $0[199] !== t53 || $0[200] !== t54 || $0[201] !== t55 || $0[202] !== t56 || $0[203] !== t57 || $0[204] !== t58 || $0[205] !== t59 || $0[206] !== t60 || $0[207] !== t61 || $0[208] !== t62 || $0[209] !== t63 || $0[210] !== t64 || $0[211] !== t65 || $0[212] !== t66 || $0[213] !== t67 || $0[214] !== t68 || $0[215] !== t69 || $0[216] !== t70 || $0[217] !== t71 || $0[218] !== t72 || $0[219] !== t73 || $0[220] !== t74) {
    t75 = {
      collect_custom_data: t39,
      custom_data: t40,
      identity_document: t41,
      selfie: t42,
      custom_document: t43,
      collect_card_data: t44,
      bank_link: t45,
      authentication: t46,
      verification_check: t47,
      verified_prefill: t48,
      input_schema: t49,
      prerequisite: t50,
      output: t51,
      complete: t52,
      external_api: t53,
      vendor_integration: t54,
      conditional: t55,
      rules: t56,
      investor_profile: t57,
      business_data: t58,
      action: t59,
      branch: t60,
      assign_data: t61,
      common_expression: t62,
      code_exec: t63,
      watchlist_review: t64,
      document_extraction: t65,
      collect_data: t66,
      identity_data: t67,
      bo_kyc: t68,
      taktile: t69,
      collect_document: t70,
      placeholder: t71,
      join_point: t72,
      ai_research: t73,
      ai_decision: t74
    };
    $0[185] = t39;
    $0[186] = t40;
    $0[187] = t41;
    $0[188] = t42;
    $0[189] = t43;
    $0[190] = t44;
    $0[191] = t45;
    $0[192] = t46;
    $0[193] = t47;
    $0[194] = t48;
    $0[195] = t49;
    $0[196] = t50;
    $0[197] = t51;
    $0[198] = t52;
    $0[199] = t53;
    $0[200] = t54;
    $0[201] = t55;
    $0[202] = t56;
    $0[203] = t57;
    $0[204] = t58;
    $0[205] = t59;
    $0[206] = t60;
    $0[207] = t61;
    $0[208] = t62;
    $0[209] = t63;
    $0[210] = t64;
    $0[211] = t65;
    $0[212] = t66;
    $0[213] = t67;
    $0[214] = t68;
    $0[215] = t69;
    $0[216] = t70;
    $0[217] = t71;
    $0[218] = t72;
    $0[219] = t73;
    $0[220] = t74;
    $0[221] = t75;
  } else {
    t75 = $0[221];
  }
  const descriptions = t75;
  let t76;
  if ($0[222] === Symbol.for("react.memo_cache_sentinel")) {
    t76 = {
      collect_data: nodeIconConfigs.identityData,
      collect_custom_data: nodeIconConfigs.customData,
      custom_data: nodeIconConfigs.customData,
      investor_profile: nodeIconConfigs.investorProfile,
      identity_data: nodeIconConfigs.identityData,
      business_data: nodeIconConfigs.businessData,
      collect_document: nodeIconConfigs.identityDocument,
      custom_document: nodeIconConfigs.customDocument,
      identity_document: nodeIconConfigs.identityDocument,
      selfie: nodeIconConfigs.selfie,
      verification_check: nodeIconConfigs.verificationCheck,
      verified_prefill: nodeIconConfigs.verifiedPrefill,
      bo_kyc: nodeIconConfigs.boKyc,
      conditional: nodeIconConfigs.conditional,
      rules: nodeIconConfigs.rules,
      action: nodeIconConfigs.action,
      taktile: nodeIconConfigs.taktile,
      input_schema: nodeIconConfigs.inputSchema,
      prerequisite: nodeIconConfigs.prerequisite,
      output: nodeIconConfigs.output,
      complete: nodeIconConfigs.complete,
      branch: nodeIconConfigs.branch,
      join_point: nodeIconConfigs.joinPoint,
      external_api: nodeIconConfigs.externalApi,
      vendor_integration: nodeIconConfigs.vendorIntegration,
      placeholder: nodeIconConfigs.placeholder,
      bank_link: nodeIconConfigs.bankLink,
      authentication: nodeIconConfigs.authentication,
      collect_card_data: nodeIconConfigs.collectCard,
      assign_data: nodeIconConfigs.assignData,
      common_expression: nodeIconConfigs.commonExpression,
      code_exec: nodeIconConfigs.codeExec,
      document_extraction: nodeIconConfigs.documentExtraction,
      watchlist_review: nodeIconConfigs.watchlistReview,
      ai_decision: nodeIconConfigs.aiDecision,
      ai_research: nodeIconConfigs.aiResearch
    };
    $0[222] = t76;
  } else {
    t76 = $0[222];
  }
  const icons = t76;
  let t77;
  if ($0[223] !== descriptions || $0[224] !== labels || $0[225] !== subtitles) {
    t77 = kind => ({
      title: labels[kind],
      subtitle: subtitles[kind],
      description: descriptions[kind],
      icon: icons[kind]
    });
    $0[223] = descriptions;
    $0[224] = labels;
    $0[225] = subtitles;
    $0[226] = t77;
  } else {
    t77 = $0[226];
  }
  return t77;
};
function _temp($_1) {
  return $_1.node.dataCollection;
}
function _temp2($_2) {
  return $_2.node.customDataCollection;
}
function _temp3($_3) {
  return $_3.node.customDataCollection;
}
function _temp4($_4) {
  return $_4.node.dataCollection;
}
function _temp5($_5) {
  return $_5.node.dataCollection;
}
function _temp6($_6) {
  return $_6.node.dataCollection;
}
function _temp7($_7) {
  return $_7.node.dataCollection;
}
function _temp8($_8) {
  return $_8.node.bankLink;
}
function _temp9($_9) {
  return $_9.node.authentication;
}
function _temp10($_10) {
  return $_10.node.documentCollection;
}
function _temp11($_11) {
  return $_11.node.documentCollection;
}
function _temp12($_12) {
  return $_12.node.documentCollection;
}
function _temp13($_13) {
  return $_13.node.selfie;
}
function _temp14($_14) {
  return $_14.node.verificationChecks;
}
function _temp15($_15) {
  return $_15.node.verifiedPrefill;
}
function _temp16($_16) {
  return $_16.node.boKyc;
}
function _temp17($_17) {
  return $_17.node.rules;
}
function _temp18($_18) {
  return $_18.node.rules;
}
function _temp19($_19) {
  return $_19.node.action;
}
function _temp20($_20) {
  return $_20.node.taktile;
}
function _temp21($_21) {
  return $_21.node.inputSchema;
}
function _temp22($_22) {
  return $_22.node.prerequisite;
}
function _temp23($_23) {
  return $_23.node.output;
}
function _temp24($_24) {
  return $_24.node.complete;
}
function _temp25($_25) {
  return $_25.node.branch;
}
function _temp26($_26) {
  return $_26.node.externalApi;
}
function _temp27($_27) {
  return $_27.node.vendorIntegration;
}
function _temp28($_28) {
  return $_28.node.placeholder;
}
function _temp29($_29) {
  return $_29.node.joinPoint;
}
function _temp30($_30) {
  return $_30.node.dataAssignment;
}
function _temp31($_31) {
  return $_31.node.commonExpression;
}
function _temp32($_32) {
  return $_32.node.codeExec;
}
function _temp33($_33) {
  return $_33.node.percyAi;
}
function _temp34($_34) {
  return $_34.node.percyAi;
}
function _temp35($_35) {
  return $_35.node.percyAi;
}
function _temp36($_36) {
  return $_36.node.percyAi;
}
function _temp37($_37) {
  return $_37.identityData.subtitle;
}
function _temp38($_38) {
  return $_38.identityData.subtitle;
}
function _temp39($_39) {
  return $_39.businessData.subtitle;
}
function _temp40($_40) {
  return $_40.collectCard.subtitle;
}
function _temp41($_41) {
  return $_41.bankLink.subtitle;
}
function _temp42($_42) {
  return $_42.node.authentication.lowercase;
}
function _temp43($_43) {
  return $_43.dataAssignmentNode.subtitle;
}
function _temp44($_44) {
  return $_44.watchlistReviewNode.subtitle;
}
function _temp45($_45) {
  return $_45.documentExtractionNode.subtitle;
}
function _temp46($_46) {
  return $_46.aiResearchNode.subtitle;
}
function _temp47($_47) {
  return $_47.aiDecisionNode.subtitle;
}
function _temp48($_48) {
  return $_48.expressionNode.subtitle;
}
function _temp49($_49) {
  return $_49.codeExecNode.subtitle;
}
function _temp50($_50) {
  return $_50.investorProfile.subtitle;
}
function _temp51($_51) {
  return $_51.collectDocument.identityDocument;
}
function _temp52($_52) {
  return $_52.node.selfie.lowercase;
}
function _temp53($_53) {
  return $_53.node.rules.lowercase;
}
function _temp54($_54) {
  return $_54.node.rules.lowercase;
}
function _temp55($_55) {
  return $_55.node.verificationChecks.lowercase;
}
function _temp56($_56) {
  return $_56.node.action.lowercase;
}
function _temp57($_57) {
  return $_57.node.verifiedPrefill.lowercase;
}
function _temp58($_58) {
  return $_58.node.boKyc.lowercase;
}
function _temp59($_59) {
  return $_59.node.taktile.lowercase;
}
function _temp60($_60) {
  return $_60.node.inputSchema.lowercase;
}
function _temp61($_61) {
  return $_61.node.prerequisite.lowercase;
}
function _temp62($_62) {
  return $_62.node.output.lowercase;
}
function _temp63($_63) {
  return $_63.node.complete.lowercase;
}
function _temp64($_64) {
  return $_64.node.branch.lowercase;
}
function _temp65($_65) {
  return $_65.node.externalApi.lowercase;
}
function _temp66($_66) {
  return $_66.node.vendorIntegration.lowercase;
}
function _temp67($_67) {
  return $_67.node.customDataCollection.lowercase;
}
function _temp68($_68) {
  return $_68.node.customDataCollection.lowercase;
}
function _temp69($_69) {
  return $_69.node.documentCollection.lowercase;
}
function _temp70($_70) {
  return $_70.node.documentCollection.lowercase;
}
function _temp71($_71) {
  return $_71.node.placeholder.lowercase;
}
function _temp72($_72) {
  return $_72.node.joinPoint.lowercase;
}
function _temp73($_73) {
  return $_73.addNode.descriptions.collectCustomData;
}
function _temp74($_74) {
  return $_74.addNode.descriptions.collectCustomData;
}
function _temp75($_75) {
  return $_75.addNode.descriptions.identityDocument;
}
function _temp76($_76) {
  return $_76.addNode.descriptions.selfie;
}
function _temp77($_77) {
  return $_77.addNode.descriptions.customDocument;
}
function _temp78($_78) {
  return $_78.addNode.descriptions.collectCardData;
}
function _temp79($_79) {
  return $_79.addNode.descriptions.bankLink;
}
function _temp80($_80) {
  return $_80.addNode.descriptions.authentication;
}
function _temp81($_81) {
  return $_81.addNode.descriptions.verificationCheck;
}
function _temp82($_82) {
  return $_82.addNode.descriptions.verifiedPrefill;
}
function _temp83($_83) {
  return $_83.addNode.descriptions.inputSchema;
}
function _temp84($_84) {
  return $_84.addNode.descriptions.prerequisite;
}
function _temp85($_85) {
  return $_85.addNode.descriptions.output;
}
function _temp86($_86) {
  return $_86.addNode.descriptions.complete;
}
function _temp87($_87) {
  return $_87.addNode.descriptions.externalApi;
}
function _temp88($_88) {
  return $_88.addNode.descriptions.vendorIntegration;
}
function _temp89($_89) {
  return $_89.addNode.descriptions.conditionalSubtree;
}
function _temp90($_90) {
  return $_90.addNode.descriptions.rules;
}
function _temp91($_91) {
  return $_91.addNode.descriptions.investorProfile;
}
function _temp92($_92) {
  return $_92.addNode.descriptions.businessData;
}
function _temp93($_93) {
  return $_93.addNode.descriptions.action;
}
function _temp94($_94) {
  return $_94.addNode.descriptions.branch;
}
function _temp95($_95) {
  return $_95.addNode.descriptions.assignData;
}
function _temp96($_96) {
  return $_96.addNode.descriptions.commonExpression;
}
function _temp97($_97) {
  return $_97.addNode.descriptions.codeExec;
}
function _temp98($_98) {
  return $_98.addNode.descriptions.watchlistReview;
}
function _temp99($_99) {
  return $_99.addNode.descriptions.documentExtraction;
}
function _temp100($_100) {
  return $_100.addNode.descriptions.collectIdentityData;
}
function _temp101($_101) {
  return $_101.addNode.descriptions.collectIdentityData;
}
function _temp102($_102) {
  return $_102.addNode.descriptions.default;
}
function _temp103($_103) {
  return $_103.addNode.descriptions.default;
}
function _temp104($_104) {
  return $_104.addNode.descriptions.default;
}
function _temp105($_105) {
  return $_105.addNode.descriptions.default;
}
function _temp106($_106) {
  return $_106.addNode.descriptions.default;
}
function _temp107($_107) {
  return $_107.addNode.descriptions.aiResearch;
}
function _temp108($_108) {
  return $_108.addNode.descriptions.aiDecision;
}